var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M5.79251 12.6586L16.8932 23.7286C17.2569 24.0911 17.8458 24.0905 18.2088 23.7267C18.5717 23.363 18.5707 22.7739 18.207 22.4111L7.76702 12L18.2074 1.58889C18.5711 1.22608 18.572 0.637281 18.2092 0.273533C18.0272 0.0911903 17.7888 1.9013e-05 17.5503 1.89921e-05C17.3125 1.89714e-05 17.0749 0.0905799 16.8933 0.271658L5.79251 11.3414C5.61734 11.5157 5.51904 11.7528 5.51904 12C5.51904 12.2471 5.61762 12.484 5.79251 12.6586Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"24","height":"24","fill":"white","transform":"translate(24 24) rotate(-180)"})))]);
}

ChevronLeftInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
